// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';
import auth from '../auth/auth';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const user = auth.getUser();

  return (
    <MAvatar
      src={user.photoURL}
      alt={user.name}
      color={user.photoURL ? 'default' : createAvatar(user.name).color}
      {...other}
    >
      {createAvatar(user.name).name}
    </MAvatar>
  );
}
